import { useContext } from 'react';
import { AppDataContext } from '../components/AppDataProvider/AppDataProvider';

const useAppData = () => useContext(AppDataContext)

export default useAppData;
